import { Component } from '@angular/core';
import {BoostrapModalService} from "../../core/services/boostrap-modal/boostrap-modal.service";


@Component({
  selector: 'app-bs-modal',
  standalone: true,
  imports: [],
  templateUrl: './bs-modal.component.html',
  styleUrl: './bs-modal.component.scss'
})
export class BsModalComponent {
  protected modalShowing: boolean;

  constructor(protected bsService:BoostrapModalService) {

  }
  ngOnInit() {

    this.bsService.modalState$.subscribe((isShown) => {

      this.modalShowing=isShown !==null;
    });
  }
}
